import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { FaBars, FaTimes } from "react-icons/fa";

const GalleryDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [albumName, setAlbumName] = useState("");
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const imageRefs = useRef([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    fetch(`https://deoria.ilakshyaerp.in/api/gallery/album/${id}`)
      .then((res) => res.json())
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        setImages(data);
      });

    fetch("https://deoria.ilakshyaerp.in/api/gallery/album")
      .then((res) => res.json())
      .then((res) => {
        const albums = Array.isArray(res) ? res : [];

        const found = albums.find(
          (a) => String(a.id) === String(id)
        );

        if (found) setAlbumName(found.name);
      });
  }, [id]);

  /* LEFT CLICK => RIGHT SCROLL */
  const goToImage = (index) => {
    setCurrent(index);

    imageRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  /* RIGHT SCROLL => LEFT ACTIVE */
  const handleScroll = () => {
    let activeIndex = 0;

    imageRefs.current.forEach((img, index) => {
      if (img) {
        const top = img.getBoundingClientRect().top;

        if (top <= 200) {
          activeIndex = index;
        }
      }
    });

    setCurrent(activeIndex);
  };

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />

      {/* GOOGLE DRIVE VIEWER */}
      <div className="drive-viewer">

        {/* TOPBAR */}
        <div className="drive-topbar">

          <div className="drive-left-top">
            <FaBars />
            <span>{albumName}</span>
          </div>

          <button
            className="drive-close"
            onClick={() => navigate("/gallery")}
          >
            <FaTimes />
          </button>

        </div>

        {/* BODY */}
        <div className="drive-body">

          {/* LEFT SIDE */}
          <div className="drive-sidebar">

            {images.map((img, index) => (
              <div
                key={img.id}
                className={`thumb-box ${current === index
                  ? "active-thumb"
                  : ""
                  }`}
                onClick={() => goToImage(index)}
              >
                <span>{index + 1}</span>

                <img
                  src={`https://deoria.ilakshyaerp.in/uploads/gallery/${img.image}`}
                  alt=""
                />
              </div>
            ))}

          </div>

          {/* RIGHT SIDE ALL IMAGES */}
          <div
            className="drive-main"
            onScroll={handleScroll}
          >
            {images.map((img, index) => (
              <div
                key={img.id}
                ref={(el) =>
                  (imageRefs.current[index] = el)
                }
                className="drive-page"
              >

                <img
                  className="drive-big-img"
                  src={`https://deoria.ilakshyaerp.in/uploads/gallery/${img.image}`}
                  alt=""
                  onClick={() =>
                    setFullscreenImage(
                      `https://deoria.ilakshyaerp.in/uploads/gallery/${img.image}`
                    )
                  }
                />

                {fullscreenImage && (
                  <div
                    className="gallery-fullscreen"
                    onClick={() =>
                      setFullscreenImage(null)
                    }
                  >
                    <button
                      className="gallery-close"
                      onClick={(e) => {
                        e.stopPropagation();
                        setFullscreenImage(null);
                      }}
                    >
                      ✕
                    </button>

                    <img
                      src={fullscreenImage}
                      alt=""
                      className="gallery-full-image"
                      onClick={(e) =>
                        e.stopPropagation()
                      }
                    />
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>

      </div>

      <Footer />
    </>
  );
};

export default GalleryDetail;